import { cn } from "@/lib/utils";
import { forwardRef } from "react";

interface GradientBorderProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Additional classes to apply (e.g., for z-index customization) */
  className?: string;
}

/**
 * A decorative gradient border overlay that creates a subtle
 * multi-point radial gradient effect around the edges of a container.
 * Should be used as an absolute positioned child within a relative parent.
 */
const GradientBorder = forwardRef<HTMLDivElement, GradientBorderProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "absolute inset-0 rounded-2xl pointer-events-none",
          className,
        )}
        style={{
          background:
            "radial-gradient(circle at top left, rgba(243,243,243,0.4) 0%, rgba(243,243,243,0.1) 40%, transparent 60%), radial-gradient(circle at top right, rgba(243,243,243,0.1) 0%, rgba(243,243,243,0.1) 40%, transparent 60%), radial-gradient(circle at bottom left, rgba(243,243,243,0.1) 0%, rgba(243,243,243,0.1) 40%, transparent 60%), radial-gradient(circle at bottom right, rgba(243,243,243,0.4) 0%, rgba(243,243,243,0.1) 40%, transparent 60%)",
          WebkitMask:
            "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
          padding: "2px",
        }}
        {...props}
      />
    );
  },
);

export { GradientBorder };
